import React, { useState } from "react";
import { Table, Tooltip, Button, message } from "antd";
import moment from "moment-timezone";
import CallReceivedIcon from "@material-ui/icons/CallReceived";
import CallMadeIcon from "@material-ui/icons/CallMade";

const CallHistory = ({ dataSource }) => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
  });

  const viewModuleDetails = (record) => {
    console.log("record:", record);

    if (
      !record.moduleid &&
      record.module !== "Call-Back" &&
      record.module !== "new_customer"
    ) {
      message.info("No module details available for this record");
      return;
    }
    const phone =
      record.direction === "outbound"
        ? record.to.slice(2)
        : record.from.slice(2);

    switch (record.module) {
      case "new_customer":
        // setCustomerId();
        // setNewCustomerPhone(phone);
        // setNewCustomerModalVisible(true);
        break;
      case "jobOrder":
      case "Job-Order":
        localStorage.setItem(
          "jobOrderState",
          JSON.stringify({ jobId: record.moduleid })
        );
        window.open("/autoadmin/job_order", "_blank");
        break;
      case "Booking":
        localStorage.setItem(
          "bookingState",
          JSON.stringify({ addFlag: true, id: record.moduleid })
        );
        window.open("/autoadmin/booking_register", "_blank");
        break;
      case "Customer":
        localStorage.setItem(
          "customerState",
          JSON.stringify({ phone: phone, editable: true })
        );
        window.open("/autoadmin/customer_details", "_blank");
        break;
      case "Quotation":
      case "Follow-Ups":
        window.open(
          `/autoadmin/follow-ups/${phone}/fupdate/${record.moduleid}`,
          "_blank"
        );
        break;
      case "Call-Back":
        message.info(
          `Call Back for missed call from ${record.user_name} to ${record.customer_name}`
        );
        break;
      case "Insurance":
        var route = `/autoadmin/insurance_renewal_reminder/${record.moduleid}`;
        window.open(route, "_blank");
        break;
      case "Other insurance":
        window.open(
          `/autoadmin/other_insurance_renewal_reminder/${record.moduleid}`,
          "_blank"
        );
        break;
      case "Service":
        window.open(
          `/autoadmin/service-followups/${phone}/fupdate/${record.moduleid}`,
          "_blank"
        );
        break;
      default:
        message.info("No module details available for this record");
        break;
    }
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "date",
      render: (text) => moment(text).format("DD/MM/YYYY"),
    },
    {
      title: "Time",
      dataIndex: "createdAt",
      key: "time",
      render: (text) => moment.utc(text).tz("Asia/Kolkata").format("hh:mm A"),
    },
    {
      title: "Customer Number",
      key: "number",
      render: (_, record) => {
        const isInbound = record.direction === "inbound";
        const phoneNumber = isInbound ? record.from : record.to;
        const isMissed = record.status === "missed";

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            {isInbound ? (
              <Tooltip title="Incoming Call">
                <CallReceivedIcon
                  style={{ color: isMissed ? "red" : "green", fontSize: 16 }}
                />
              </Tooltip>
            ) : (
              <Tooltip title="Outgoing Call">
                <CallMadeIcon
                  style={{ color: isMissed ? "red" : "blue", fontSize: 16 }}
                />
              </Tooltip>
            )}
            <span>{phoneNumber || "-"}</span>
          </div>
        );
      },
    },
    {
      title: "Employee Name",
      dataIndex: "user_name",
      key: "user_name",
      render: (text) => text || "Unknown",
    },
    {
      title: "Hangup Reason",
      dataIndex: "hangup_reason",
      key: "hangup_reason",
      render: (reason) => {
        const reasonMap = {
          sent_bye: "Call ended by customer",
          recv_bye: "Call ended by employee",
          recv_cancel: "Call unanswered",
          sent_reject: "Call rejected by customer",
          normal: "Call ended normally",
        };

        return reasonMap[reason] || "No reason provided";
      },
    },
    {
      title: "Module",
      key: "module",
      render: (record) => {
        const isValidModule = record.module !== "null" && record.module;

        return (
          <Button
            type="default"
            size="small"
            className={isValidModule ? "linkylink" : ""}
            style={{
              width: "105px",
              cursor: isValidModule ? "pointer" : "not-allowed",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            disabled={!isValidModule}
            onClick={(e) => {
              e.stopPropagation();
              if (isValidModule) viewModuleDetails(record);
            }}
          >
            {isValidModule ? record.module : "-"}
          </Button>
        );
      },
    },
    {
      title: "Recording",
      dataIndex: "bucketURL",
      key: "recording",
      width: 210,
      align: "center",
      render: (url, record) => {
        const isMissed = record.status === "missed";

        return isMissed || !url ? (
          "-"
        ) : (
          <audio
            controls
            style={{
              width: "170px",
              height: "40px",
              transform: "scale(0.8)",
            }}
          >
            <source src={url} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        );
      },
    },
  ].filter(Boolean);

  return (
    <div>
      <Table
        dataSource={dataSource}
        columns={columns}
        rowKey="id"
        pagination={{
          pageSize: 20,
          current: pagination.current,
          onChange: (page, pageSize) =>
            setPagination({ current: page, pageSize }),
        }}
      />
    </div>
  );
};

export default CallHistory;
